import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';

export const useAuthorize = () => {
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const history = useHistory();
    const navigateEffect = () => history.push(PATH.LOGIN);
    if (!userDetail) {
        return { isAuthorize: false, navigateEffect };
    } else {
        return { isAuthorize: true, navigateEffect };
    }
};
